import {
  NotAllowMplusForRolesUser,
  UserAuthorityType,
} from 'entities/user/module'

import { ActiveMplusStatuses, MIN_MPLUS_PRICE } from 'shared/constants'

import { MplusStatuses } from '../module'

interface GetCurrentStatusProps {
  priceRequest: number
  userRole: string
  mplusStatus: string
  availableAmountMplus: number
}

export const getCurrentStatusMplus = ({
  userRole,
  mplusStatus,
  priceRequest,
  availableAmountMplus,
}: GetCurrentStatusProps) => {
  // сумма запроса меньше чем 500
  if (priceRequest < MIN_MPLUS_PRICE) {
    return MplusStatuses.NOT_ALLOW_PRICE.key
  }

  // Не отображать мплюс для тип пользователей
  if (NotAllowMplusForRolesUser.includes(userRole as UserAuthorityType)) {
    return MplusStatuses.NOT_ALLOW.key
  }

  // активен ли мплюс пользователю
  if (ActiveMplusStatuses.includes(mplusStatus)) {
    // Не достаточно средст в мплюсе для данного заказа
    if (priceRequest > availableAmountMplus) {
      return MplusStatuses.NOT_ENOUGH_CASH.key
    }

    // Можно оплатить мплюсом
    if (priceRequest <= availableAmountMplus) {
      return MplusStatuses.ALLOW.key
    }
  }

  return MplusStatuses.INCLUDE.key
}
